import authHeader from "../../authentication/authservices/auth-header";
import apiClient from "../../http-common"  ;

//-------------------------------------------------------- innamdar services -----------------------------------------------------------------------------------


// searchString
export const getPatientBysearchString = async (searchObj) => {
    return await apiClient.post(`/admission/admissionPatientListSearch`, searchObj, {
        headers: authHeader()
    });
};



// searchString
export const getPreviousVisitoryBysearchString = async (searchString) => {
    return await apiClient.get(`/visitorTracker/visitor/${searchString}`, {
        headers:authHeader()
    });
};

//Save
export const saveVisitor = async (finalData) => {
    return await apiClient.post(`/visitorTracker/save`, finalData, {
        headers:authHeader()
    });
};


// get All Visistor List
export const getAllVisitorList = async (formObject) => {
    return await apiClient.post(`/visitorTracker/list`, formObject, {
        headers:authHeader()
    });
};


export const cancelVisitorPass = async (visitorId) => {
    return await apiClient.get(`/visitorTracker/cancelledStatus/${visitorId}`, {
        headers:authHeader()
    });
};



export const checkOutVisitor = async (visitorId) => {
    return await apiClient.get(`/visitorTracker/visitorCheckOut/${visitorId}`, {
        headers:authHeader()
    });
};


// searchString
export const getEmployeeBysearchString = async (searchString) => {
    return await apiClient.get(`/visitorTracker/whomToMeet/${searchString}`, {
        headers:authHeader()
    });
};
export const fetchAdmissionList = (searchStringParams) => {
    return apiClient.post(`/admission/admissionPatientList`, searchStringParams, {
        headers: authHeader(),
    });
};
//get Location dropdown
export const getLocationDropdown = async () => {
    return await apiClient.get(`/misc/ward`, {
        headers:authHeader()
    });
};


//get Location dropdown
export const getdocumentTypeDropdown = async () => {
    return await apiClient.get(`/misc/documents`, {
        headers:authHeader()
    });
};

//get Location dropdown
export const prefixDropdown = async () => {
    return await apiClient.get(`/misc/salutation`, {
        headers:authHeader()
    });
};


//get department SearchString
export const departmentDropdown = async (searchString) => {
    return await apiClient.get(`/misc/department/${searchString}`, {
        headers:authHeader()
    });
};


